/**
 * 審査ステータスの見た目(色種別・アイコン)の対応表。
 *
 * フィルタのタブと検索結果一覧の両方で同じ定義を使うことで、
 * 「タブで選んだ色 = 一覧に並ぶ色」を必ず一致させる。
 * 別々に持つと、片方だけ直して食い違う事故が起きる。
 */
export type StatusTone = 'all' | 'prep' | 'exam' | 'hold' | 'ok' | 'lng' | 'ng'

export interface StatusStyle {
  tone: StatusTone
  icon: string
}

/** キーは (JudgmentStatusCode + JudgmentSubStatusCode) */
export const STATUS_STYLE: Record<string, StatusStyle> = {
  all: { tone: 'all', icon: 'list' },
  '10': { tone: 'prep', icon: 'clock' },   // 審査中(不明)
  '11': { tone: 'prep', icon: 'clock' },   // 審査中(準備)
  '12': { tone: 'exam', icon: 'search' },  // 審査中(審査)
  '15': { tone: 'hold', icon: 'pause' },   // 審査中(保留)
  '20': { tone: 'ok', icon: 'check' },     // 審査OK
  '80': { tone: 'lng', icon: 'ban' },      // 出品NG
  '90': { tone: 'ng', icon: 'cross' },     // 審査NG
}

/** 主コード単位のフォールバック(マスタ未定義の組み合わせ用) */
const BY_MAIN: Record<string, StatusStyle> = {
  '1': { tone: 'exam', icon: 'search' },
  '2': { tone: 'ok', icon: 'check' },
  '8': { tone: 'lng', icon: 'ban' },
  '9': { tone: 'ng', icon: 'cross' },
  A: { tone: 'prep', icon: 'clock' },
}

/**
 * ステータスコードから見た目を解決する。
 * 実データにはマスタ未定義の組み合わせ((2,1)(8,1)(9,1)等)も存在するため、
 * 完全一致 → 主コード の順にフォールバックする。
 */
export function resolveStatusStyle(main: string, sub?: string): StatusStyle {
  return (
    STATUS_STYLE[`${main}${sub ?? ''}`] ??
    STATUS_STYLE[`${main}0`] ??
    BY_MAIN[main] ??
    { tone: 'prep', icon: 'clock' }
  )
}
